import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze zipů — vlastní číselník (v Tabidoo nebyl), funguje stejně jako nitě. */
export function DatabazeZipuPage() {
  return (
    <TabidooTablePage
      table="zipy"
      storagePrefix="zipy"
      title="Databáze zipů"
      subtitle="Barvy a velikosti zipů. Hledej globálně, filtruj po sloupcích, přehazuj sloupce tažením. Klikni na řádek pro detail a editaci."
      createLabel="Nový zip"
    />
  );
}
